module.exports = __webpack_public_path__ + "img/live-electric-tours.55fa23eb.jpg";